/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Close from '@mui/icons-material/Close';

import { Typo } from 'uikit/content';
import { Button } from 'uikit/buttons';
import { Avatar } from 'uikit/avatars';
import { Tooltip } from 'uikit/tooltips';

import getGroupsMembersText from '../helpers/getGroupsMembersText';

import styles from '../styles/exceedGroupsCustomListItem.module.scss';

const ExceedGroupsCustomListItem = ({
  handleRemoveSelected,
  onClick = () => {},
  hasButton = true,
  className = '',
  isClickable = false,
  buttonAriaLabel = 'Remove',
  isDisabled,
  selectedItem: { metadata, ...selectedItem } = {},
  tooltipText,
}) => {
  const {
    avatar = selectedItem.avatar || selectedItem.avatar_path,
    code,
    eligibleMembers = selectedItem.eligibleMembers || metadata?.number_of_eligible_members,
    id,
    jobTitle = selectedItem.jobTitle || metadata?.job_title,
    membersCount = selectedItem.membersCount ?? metadata?.number_of_members,
    name,
    type,
  } = selectedItem;

  const membersText = getGroupsMembersText(eligibleMembers, membersCount);

  const Element = type === 'group' && isClickable ? Button : Typo;

  const ButtonWrapper = isDisabled ? Tooltip : Fragment;

  const tooltipProps = isDisabled ? { content: tooltipText } : null;

  let elementProps = {};

  if (type === 'group' && isClickable) {
    elementProps = {
      variant: 'link',
      onClick: () => {
        onClick({ name, groupId: id });
      },
    };
  } else {
    elementProps = {
      element: 'span',
      variant: 's02',
      weight: 'medium',
      onClick: () => {},
    };
  }

  return (
    <li className={classnames(styles.element, className)}>
      <div className={styles.container}>
        <div className={styles.contentWrap}>
          <div className={styles.avi} data-testid="exceed-groups-list-item-avatar">
            <Avatar avatar={avatar} size="medium" showInitials={!avatar} name={name} ariaHidden />
            <div className={styles.userInfo}>
              <Element {...elementProps}>{name}</Element>
              <div className={styles.meta}>
                {type === 'user' && jobTitle && (
                  <Typo element="span" title={jobTitle} variant="s01">
                    {jobTitle}
                  </Typo>
                )}
                {type === 'group' && (
                  <Typo element="span" title={eligibleMembers || membersCount} variant="s01">
                    {membersText}
                  </Typo>
                )}
                {code && (
                  <div className={styles.codeWrap}>
                    <Typo element="span" title={code} variant="s01" className={styles.code}>
                      {code}
                    </Typo>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {hasButton && (
          <ButtonWrapper {...tooltipProps}>
            <div className={styles.action}>
              <Button
                ariaLabel={buttonAriaLabel}
                variant="ghost"
                size="xsmall"
                icon={<Close />}
                onClick={() => handleRemoveSelected(id)}
                isDisabled={isDisabled}
              />
            </div>
          </ButtonWrapper>
        )}
      </div>
    </li>
  );
};

ExceedGroupsCustomListItem.propTypes = {
  buttonAriaLabel: PropTypes.string,
  onClick: PropTypes.func,
  hasButton: PropTypes.bool,
  className: PropTypes.string,
  isClickable: PropTypes.bool,
  selectedItem: PropTypes.oneOfType([
    PropTypes.shape({
      avatar_path: PropTypes.string,
      code: PropTypes.string,
      id: PropTypes.number,
      metadata: PropTypes.shape({
        job_title: PropTypes.string,
        number_of_eligible_members: PropTypes.string,
        number_of_members: PropTypes.number,
      }),
      name: PropTypes.string,
      type: PropTypes.oneOf(['group', 'user']),
    }),
    PropTypes.shape({
      avatar: PropTypes.string,
      code: PropTypes.string,
      eligibleMembers: PropTypes.string,
      id: PropTypes.number,
      jobTitle: PropTypes.string,
      membersCount: PropTypes.number,
      name: PropTypes.string,
      type: PropTypes.oneOf(['group', 'user']),
    }),
  ]),
};

export default ExceedGroupsCustomListItem;
